import React, { Component } from "react";
import { Modal, Form, Input, InputNumber, Select, Switch } from "antd";

import http from "../../../axios/http";
import server from "../../../axios/server";

const FormItem = Form.Item;

class ParkGateEditForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      feeRules: [],
      parkZones: [],
    };
  }

  save = () => {
    const { editData, form } = this.props;
    form.validateFields((err, values) => {
      if (err) {
        return;
      }
      if (editData.id) values["id"] = editData.id;
      http.post({
        url: "/barrier/parkgate/save",
        data: values,
        success: (res) => {
          http.post({
            url:
              server.mallServerUrl + "/externalApi/barrier/updateParkGateCache",
            data: { id: editData.id },
            success: (res) => {
              console.log("mallapi道闸缓存刷新成功");
            },
          });
          this.props.successCallback(this.props.queryData);
          this.props.onCancel();
        },
      });
    });
  };

  isOutClick = () => {
    const editData = this.props.editData;
    const form = this.props.form;
    form.isOut = editData.isOut = !editData.isOut;
  };

  loadFeeRules = () => {
    http.post({
      url: "/barrier/feeRule/query",
      data: { pageSize: 100 },
      success: (res) => {
        this.setState({ feeRules: res.content });
      },
    });
  };

  loadParkZone = () => {
    http.post({
      url: "/barrier/parkZone/allZone",
      success: (res) => {
        this.setState({ parkZones: res });
      },
    });
  };

  componentWillMount() {
    this.loadFeeRules();
    this.loadParkZone();
  }

  render() {
    const { visible, onCancel, form, editData } = this.props;
    const { feeRules, parkZones } = this.state;
    const { getFieldDecorator } = form;
    return (
      <Modal
        visible={visible}
        title="道闸信息编辑"
        okText="保存"
        cancelText="取消"
        maskClosable={false}
        onCancel={onCancel}
        onOk={this.save}
        afterClose={() => {
          this.props.form.resetFields();
        }}
      >
        <Form
          layout="vertical"
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 15 }}
        >
          <FormItem label="道闸编码：">
            {getFieldDecorator("gateNo", {
              rules: [
                { required: true, message: "请输入道闸编码!" },
                { max: 32, message: "最多只能输入32个字符！" },
              ],
              initialValue: editData.gateNo,
            })(<Input />)}
          </FormItem>
          <FormItem label="道闸名称：">
            {getFieldDecorator("name", {
              rules: [
                { required: true, message: "请输入道闸名称!" },
                { max: 32, message: "最多只能输入32个字符！" },
              ],
              initialValue: editData.name,
            })(<Input />)}
          </FormItem>
          <FormItem label="显示排序：">
            {getFieldDecorator("sortOrder", {
              initialValue: editData.sortOrder || 0,
            })(<InputNumber min={0} />)}
            越小排在越前面
          </FormItem>
          <FormItem label="道闸类型：">
            {getFieldDecorator("type", {
              initialValue: editData.type || 0,
            })(
              <Select>
                <Select.Option value={0}>不控制</Select.Option>
                <Select.Option value={1}>交易车</Select.Option>
                <Select.Option value={2}>社会车</Select.Option>
                <Select.Option value={3}>服务站</Select.Option>
                <Select.Option value={21}>场中场交易车</Select.Option>
                <Select.Option value={23}>场中场服务站</Select.Option>
              </Select>
            )}
          </FormItem>
          <FormItem label="计费规则">
            {getFieldDecorator("feeRule", {
              initialValue: editData.feeRule || 0,
            })(
              <Select>
                <Select.Option value={0}>免费</Select.Option>
                {feeRules &&
                  feeRules.map((item, index) => (
                    <Select.Option value={item.id}>{item.name}</Select.Option>
                  ))}
              </Select>
            )}
          </FormItem>
          <FormItem label="停车区域：">
            {getFieldDecorator("zone", {
              rules: [{ required: true, message: "请选择停车区域!" }],
              initialValue: editData.zone,
            })(
              <Select>
                <Select.Option value="">--请选择--</Select.Option>
                {parkZones &&
                  parkZones.map((item, index) => (
                    <Select.Option value={item.code}>{item.name}</Select.Option>
                  ))}
              </Select>
            )}
          </FormItem>
          <FormItem label="外场区域：">
            {getFieldDecorator("outerZone", {
              initialValue: editData.outerZone,
            })(
              <Select>
                <Select.Option value="">无</Select.Option>
                {parkZones &&
                  parkZones.map((item, index) => (
                    <Select.Option value={item.code}>{item.name}</Select.Option>
                  ))}
              </Select>
            )}
          </FormItem>
          <FormItem label="停车数限制：">
            {getFieldDecorator("memberLimitZone", {
              initialValue: editData.memberLimitZone || 0,
            })(
              <Select>
                <Select.Option value={0}>不控制</Select.Option>
                <Select.Option value={1}>启用控制</Select.Option>
              </Select>
            )}
          </FormItem>
          <FormItem label="状态：">
            {getFieldDecorator("state", {
              initialValue: editData.state || 0,
            })(
              <Select>
                <Select.Option value={0}>启用</Select.Option>
                <Select.Option value={-2}>停用</Select.Option>
              </Select>
            )}
          </FormItem>
          <FormItem label="是否出口：">
            {getFieldDecorator("isOut", {
              initialValue: editData.isOut || false,
            })(<Switch checked={editData.isOut} onClick={this.isOutClick} />)}
          </FormItem>
        </Form>
      </Modal>
    );
  }
}

const ParkGateEdit = Form.create()(ParkGateEditForm);

export default ParkGateEdit;
